/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from '@sentry/browser';
import { BaseTransportOptions, Client, ClientOptions } from '@sentry/core';

import { initTelemetry } from './sentry';

interface IParams {
  id: string;
  widget: any;
}
export interface IErrorsHandler {
  sentry: Client<ClientOptions<BaseTransportOptions>> | undefined;
  params: Partial<IParams>;
  setMetaData: (params: Partial<IParams>) => void;
  init: (params: Partial<IParams>, currentScriptSrc: string) => IErrorsHandler;
  send: (message: string, error: Error, widgetId?: string) => void;
}

function reportSentryError(
  error: Error,
  widgetId: string,
  message: string,
  sentry: IErrorsHandler['sentry'],
) {
  const stackLine = error.stack?.split('\n')[1]?.trim() || 'unknown';

  const customError = new (error.constructor as new (message: string) => Error)(
    `${error.name}: ${widgetId} ${message}`,
  );

  customError.stack = error.stack;

  Sentry?.withScope((scope) => {
    scope.setTag('widgetId', widgetId);
    scope.setTag('stackLine', stackLine);
    scope.setFingerprint([error.name, stackLine, widgetId]);

    sentry?.captureException(customError);
  });
}
export const ErrorsHandler: IErrorsHandler = {
  sentry: undefined,
  params: {},
  init(params, currentScriptSrc) {
    this.sentry = initTelemetry(currentScriptSrc, params);
    this.setMetaData(params);
    return this;
  },
  setMetaData(params) {
    this.params = { ...this.params, ...params };
  },
  send(message, error, widgetId) {
    if ('meta' in error) {
      // todo: проверка через typeof RequestError не работает
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const { meta } = error;
      this.sentry?.captureEvent({
        message: `Request details: ${JSON.stringify({ ...meta }, null, 2)}`,
      });
    }

    reportSentryError(error, widgetId ?? '', message, this.sentry);
  },
};
